import React, { useRef, useState, useEffect } from 'react';

import Navbar from "../../components/en/Navbar";
import Footer from "../../components/en/Footer";

import "../../styles/common.css";
import "../../styles/legal.css";

const Datenschutzerklarung = () => {

  return (
    <>
      <Navbar></Navbar>
      <main className='datenschutzerklarung'>
        <section className='fvUnder'>
          <div className='fvUnder-text'>
            <h1>Datenschutzerklärung</h1>
            <nav aria-label="Breadcrumb" className="breadcrumb">
              <ol className='breadcrumb'>
                <li><a href="/en">Home</a></li>
                <li aria-current="page">Datenschutzerklärung</li>
              </ol>
            </nav>
          </div>
        </section>
        <section className='legal'>
          <div className='legal-box'>
            <h2>1. Einleitung</h2>
            <div className='legal-box__text'>
              <p>Wir nehmen den Schutz Ihrer personenbezogenen Daten sehr ernst. In dieser Datenschutzerklärung informieren wir Sie darüber, welche personenbezogenen Daten wir erheben, wie wir diese verwenden und welche Rechte Ihnen zustehen.</p>
            </div>
          </div>
          <div className='legal-box'>
            <h2>2. Verantwortlicher </h2>
            <div className='legal-box__text'>
              <p><b>LOGOT UG</b></p>
              <p>Moerser Str 125 Im Hof, 40667 Meerbusch</p>
              <p><a href="mailto:contact@logot.de" className='button-underLine' target="_blank">contact@logot.de</a></p>
            </div>
          </div>
          <div className='legal-box'>
            <h2>3. Erhebung und Verarbeitung personenbezogener Daten</h2>
            <div className='legal-box__text'>
              <p>Wir erheben personenbezogene Daten nur im rechtlich zulässigen Rahmen und wenn Sie uns diese zur Verfügung stellen. Dies kann in folgenden Fällen geschehen:</p>
              <ul className='list-disc'>
                <li>Bei der Nutzung unserer Website</li>
                <li>Bei Kontaktaufnahme über unser Kontaktformular oder per E-Mail</li>
                <li>Bei der Anmeldung zu unserem Newsletter</li>
                <li>Bei der Nutzung unserer Dienstleistungen</li>
              </ul>
              <p className='pt1em'>Verarbeitete Datenkategorien:</p>
              <ul className='list-disc'>
                <li>Name, E-Mail-Adresse, Telefonnummer</li>
                <li>IP-Adresse, Browsertyp, Betriebssystem</li>
                <li>Cookies und Nutzungsdaten</li>
              </ul>
            </div>
          </div>
          <div className='legal-box'>
            <h2>4. Zweck der Datenverarbeitung</h2>
            <div className='legal-box__text'>
              <p>Wir verarbeiten Ihre Daten zu folgenden Zwecken:</p>
              <ul className='list-disc'>
                <li>Zur Bereitstellung und Verbesserung unserer Dienstleistungen</li>
                <li>Zur Kommunikation mit Ihnen</li>
                <li>Zur Gewährleistung der IT-Sicherheit</li>
                <li>Zur Erfüllung gesetzlicher Verpflichtungen</li>
              </ul>
            </div>
          </div>
          <div className='legal-box'>
            <h2>5. Rechtsgrundlagen der Verarbeitung</h2>
            <div className='legal-box__text'>
              <p>Die Verarbeitung Ihrer Daten erfolgt gemäß Art. 6 Abs. 1 DSGVO auf folgender Grundlage:</p>
              <ul className='list-disc'>
                <li>Ihre Einwilligung (Art. 6 Abs. 1 lit. a DSGVO)</li>
                <li>Vertragserfüllung oder vorvertragliche Maßnahmen (Art. 6 Abs. 1 lit. b DSGVO)</li>
                <li>Erfüllung rechtlicher Verpflichtungen (Art. 6 Abs. 1 lit. c DSGVO)</li>
                <li>Berechtigtes Interesse (Art. 6 Abs. 1 lit. f DSGVO)</li>
              </ul>
            </div>
          </div>
          <div className='legal-box'>
            <h2>6. Weitergabe von Daten an Dritte</h2>
            <div className='legal-box__text'>
              <p>Ihre Daten werden nicht ohne Ihre ausdrückliche Zustimmung an Dritte weitergegeben, es sei denn:</p>
              <ul className='list-disc'>
                <li>Es ist gesetzlich vorgeschrieben.</li>
                <li>Es ist zur Vertragserfüllung erforderlich.</li>
                <li>Wir setzen externe Dienstleister (z. B. Hosting-Provider) ein, die weisungsgebunden arbeiten.</li>
              </ul>
            </div>
          </div>
          <div className='legal-box'>
            <h2>7. Speicherung und Löschung von Daten</h2>
            <div className='legal-box__text'>
              <p>Wir speichern Ihre personenbezogenen Daten nur so lange, wie es zur Erfüllung der genannten Zwecke erforderlich ist oder wie es gesetzlich vorgeschrieben ist. Nach Ablauf der Fristen werden die Daten gelöscht.</p>
            </div>
          </div>
          <div className='legal-box'>
            <h2>8. Ihre Rechte</h2>
            <div className='legal-box__text'>
              <p>Gemäß DSGVO haben Sie folgende Rechte:</p>
              <ul className='list-disc'>
                <li>Recht auf Auskunft (Art. 15 DSGVO)</li>
                <li>Recht auf Berichtigung (Art. 16 DSGVO)</li>
                <li>Recht auf Löschung (Art. 17 DSGVO)</li>
                <li>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
                <li>Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</li>
                <li>Recht auf Widerspruch (Art. 21 DSGVO)</li>
                <li>Recht auf Beschwerde bei einer Datenschutzbehörde</li>
              </ul>
            </div>
          </div>
          <div className='legal-box'>
            <h2>9. Cookies und Tracking-Technologien</h2>
            <div className='legal-box__text'>
              <p>Unsere Website verwendet Cookies und ähnliche Technologien. Sie können Ihre Cookie-Einstellungen über unseren Cookie-Banner anpassen. Weitere Informationen finden Sie in unserer <a href="/en/cookiePolicy" className='button-underLine'>Cookie-Policy</a>.</p>
            </div>
          </div>
          <div className='legal-box'>
            <h2>10. Datensicherheit</h2>
            <div className='legal-box__text'>
              <p>Wir setzen technische und organisatorische Maßnahmen ein, um Ihre Daten vor unbefugtem Zugriff, Verlust oder Missbrauch zu schützen.</p>
            </div>
          </div>
          <div className='legal-box'>
            <h2>11. Änderungen der Datenschutzerklärung</h2>
            <div className='legal-box__text'>
              <p>Diese Datenschutzerklärung kann jederzeit geändert werden. Die aktuelle Version ist auf unserer Website verfügbar.</p>
              <p><b>Letzte Aktualisierung: 01.03.2025</b></p>
            </div>
          </div>

        </section>
      </main >
      <Footer></Footer>
    </>
  );
};

export default Datenschutzerklarung